/**
 * The distance from the viewport edge to the content grid, so full-bleed
 * elements (the hero name, the logo marquee) can line up with it.
 */
import { useEffect, useState } from "react";

/**
 * Left offset of CONTAINER (max-w-7xl mx-auto px-6 sm:px-12 lg:px-16, 16px
 * root) at a viewport width: its padding plus the centring margin once the
 * container reaches its 80rem max width.
 * @param {number} viewportWidth px
 * @returns {number} px
 */
export function containerOffset(viewportWidth) {
	const pad = viewportWidth < 640 ? 24 : viewportWidth < 1024 ? 48 : 64;
	const margin = viewportWidth > 1280 ? Math.round((viewportWidth - 1280) / 2) : 0;
	return margin + pad;
}

/** containerOffset of the current window, kept up to date on resize. */
export function useContainerOffset() {
	const [offset, setOffset] = useState(() => containerOffset(window.innerWidth));
	useEffect(() => {
		const onResize = () => setOffset(containerOffset(window.innerWidth));
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);
	return offset;
}
